<div class="filter-content">
  <ng-scrollbar>
    <div class="filter-container">
      <dynamic-form [config]="membershipConfig" #form="dynamicForm">
      </dynamic-form>
      @if (hasMembershipValue && membershipValid) {
        <span class="membership-detail"
          >{{'MemberType'
          |
          translate}} :
          {{activityService.selectedGuest.MembershipType}}
        </span>
      }
      @if (hasMembershipValue && !membershipValid && !inputvalidation) {
        <span class="custom-error"
          >{{'InvalidMembershipDetail'
        | translate}}</span>
      }
      @if (hasMembershipValue && membershipValid) {
        <span class="custom-error"
        >({{membershipStatus}})</span>
      }
      <dynamic-form [config]="reservationConfig" #form="dynamicForm">
      </dynamic-form>
      <div class="mt-3 chip-control reservation-details__meal-period">
        <div class="default-sub-header text-label pb-0"></div>
        @for (option of days; track option) {
          <section class="dynamic-section reservation-details__meal-period">
            <mat-checkbox class="chip-control__checkbox" [checked]="checkAvailableDate(option.id)"
              (change)="getAvailableDays(option.id)">{{option.day}}
            </mat-checkbox>
          </section>
        }
      </div>
    </div>
  </ng-scrollbar>
</div>
<div class="p-10">
  <div class="row m-0">
    <div class="col-lg-6 col-md-6 text-right">
      <app-button [buttontype]="previousButton" (valueChange)="resetFilter()"></app-button>
    </div>
    <div class="col-lg-6 col-md-6 ps-1">
      <app-button [buttontype]="nextButton" (valueChange)="getFilterValues()"></app-button>
    </div>
  </div>

</div>